import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ebb59bae&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ebb59bae&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb59bae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebb59bae')) {
      api.createRecord('ebb59bae', component.options)
    } else {
      api.reload('ebb59bae', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ebb59bae&scoped=true", function () {
      api.rerender('ebb59bae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/BigData/index.vue"
export default component.exports